import { render } from "./TournamentLeagueScoring.vue?vue&type=template&id=5e0b2d76&scoped=true"
import script from "./TournamentLeagueScoring.vue?vue&type=script&lang=js"
export * from "./TournamentLeagueScoring.vue?vue&type=script&lang=js"

import "./TournamentLeagueScoring.vue?vue&type=style&index=0&id=5e0b2d76&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0b2d76"]])

export default __exports__